import { ReactElement, useEffect } from 'react'
import { ThemeProvider } from 'styled-components'
import GlobalStyles from 'globalStyles'
import { palette } from 'configureBrand'
import Header from 'ui/organisms/Header'
import Footer from 'ui/organisms/Footer'
import BackToTop from 'ui/atoms/BackToTop'
import ScrollToTop from 'ui/atoms/ScrollToTop'
import SkipToContent from 'ui/atoms/SkipToContent'
import { isIE } from 'helpers'
import { FlagsProvider } from 'flagged'
import { useAppDispatch } from 'redux/hooks'
import { fetchCommonConfig } from 'redux/config/configSlice'
import { Switch } from 'react-router-dom'
import routePaths from 'const/routePaths'
import SessionTimeOut from 'ui/organisms/SessionTimeOut'
import Maintenance from 'ui/molecules/Maintenance/Maintenance'
import {
  AppContainer,
  Main,
  PublicRoute,
  withPageLoader
} from './subcomponents'
import RefreshModal from './RefreshModal'
import Routes from './Routes'
import MockApi from './MockApi'
import { CardActivationLazy, CliQuestionnaireLazy } from './lazyLoad'

const App = (): ReactElement => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(fetchCommonConfig())
  }, [dispatch])

  return (
    <FlagsProvider>
      <ThemeProvider theme={palette}>
        <ScrollToTop>
          <AppContainer>
            <SkipToContent />
            <GlobalStyles />
            {isIE() ? (
              <Routes isIE />
            ) : (
              <Switch>
                <PublicRoute
                  path={routePaths.activation}
                  component={withPageLoader(CardActivationLazy)}
                />
                <PublicRoute
                  path={routePaths.cliQuestionnaire}
                  component={withPageLoader(CliQuestionnaireLazy)}
                />
                <>
                  <SessionTimeOut />
                  <Header />
                  <RefreshModal />
                  <Main id="mainContent">
                    <Maintenance>
                      <Routes />
                    </Maintenance>
                  </Main>
                  <Footer />
                </>
              </Switch>
            )}
            <BackToTop />
          </AppContainer>
        </ScrollToTop>
        <MockApi />
      </ThemeProvider>
    </FlagsProvider>
  )
}

export default App
